import { useTranslation } from 'react-i18next';

import { Button } from '../buttons/Button';
import { GoogleFontIcon } from '../icons/GoogleFontIcon';

import styles from './PdfPreviewSearchBar.module.scss';

type PdfPreviewSearchBarProps = {
  query: string;
  matches: {
    current: number;
    total: number;
  };
  onQueryChange: (value: string) => void;
  onFind: (findPrevious?: boolean) => void;
  onClose: () => void;
};

export function PdfPreviewSearchBar({
  query,
  matches,
  onQueryChange,
  onFind,
  onClose,
}: PdfPreviewSearchBarProps) {
  const { t } = useTranslation();

  return (
    <div className={styles['search']}>
      <GoogleFontIcon name="search" />
      <input
        autoFocus
        className={styles['search-input']}
        onChange={(event) => onQueryChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            onFind(event.shiftKey);
          }
        }}
        placeholder={t('app.pdfDocumentPreview.searchPlaceholder')}
        value={query}
      />
      <span className={styles['quiet']}>
        {matches.total
          ? `${matches.current}/${matches.total}`
          : t('app.pdfDocumentPreview.noResults')}
      </span>
      <Button
        icon={<GoogleFontIcon name="keyboard_arrow_up" />}
        onClick={() => onFind(true)}
        title={t('app.pdfDocumentPreview.previousMatch')}
        variant="text"
      />
      <Button
        icon={<GoogleFontIcon name="keyboard_arrow_down" />}
        onClick={() => onFind(false)}
        title={t('app.pdfDocumentPreview.nextMatch')}
        variant="text"
      />
      <Button
        icon={<GoogleFontIcon name="close" />}
        onClick={onClose}
        title={t('app.pdfDocumentPreview.closeSearch')}
        variant="text"
      />
    </div>
  );
}
